import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { ChatBotService } from "src/app/core/services/chatbox.service";
import { PLATFORM_ROLES } from "src/app/models/common";
import { AppConfig } from "src/app/configs/app.config";

@Component({
  selector: "app-chatbot-panel",
  templateUrl: "./chatbot-panel.component.html",
  styleUrls: ["./chatbot-panel.component.scss"],
})
export class ChatbotPanelComponent implements OnInit {
  @Input() isShowChatPanel: boolean = false;
  @Input() minimizeChatPanel: boolean = false;
  @Input() globalParams: {};
  @Input() userRole: string = "";

  @Output() toggleChatPanel = new EventEmitter<boolean>();
  @Output() minimizePanel = new EventEmitter<boolean>();

  messages: Array<any> = [];
  isTyping: boolean = false;
  isRestore: boolean = true;
  isShowPrompt: boolean = false;
  readonly imgPath: string;

  constructor(
    private commonService: CommonService,
    private chatBotService: ChatBotService
  ) {
    this.imgPath = AppConfig.POPUP_LOGO;
    this.commonService.getSelectedQueryFromUser.subscribe((res) => {
      this.messages.push({
        from: "user",
        text: res.query,
      });
      this.handleUserQuery(
        false,
        res.queryType == "question" ? res.queryId : null,
        res.queryType == "question" ? {} : { category: res.query },
        res.queryType
      );
    });
  }

  ngOnInit() {
    this.handleUserQuery(true);
  }

  handleUserQuery(
    initial: boolean = false,
    $event = null,
    params: Object = {},
    queryType: string = "userInput"
  ) {
    this.isTyping = true;
    let data = {};
    if (initial) {
      params["initial"] = 0;
    } else if (queryType == "userInput") {
      this.messages.push({
        from: "user",
        text: $event,
        queryType: queryType,
      });
      data = {
        text: $event,
      };
    } else if (queryType == "question") {
      data = {
        id: $event,
      };
    }
    if (!PLATFORM_ROLES.has(this.userRole)) {
      params = { ...params, ...this.globalParams };
    }
    this.chatBotService.create(data, params).subscribe({
      next: (res) => {
        setTimeout(() => {
          this.messages.push({
            from: "bot",
            text: res.data,
            queryType:
              queryType == "question" ? "queryClarification" : queryType,
          });
          this.isTyping = false;
        }, 500);
      },
      error: (res) => {
        setTimeout(() => {
          this.messages.push({
            from: "bot",
            text: res.error,
            queryType: queryType,
          });
          this.isTyping = false;
        }, 500);
      },
    });
  }

  updateMinimizeState() {
    this.minimizePanel.emit(this.minimizeChatPanel);
  }

  goToQuery(index) {
    if (index == 0) {
      this.messages.push(this.messages[index]);
    } else {
      this.messages.push(this.messages[index - 1], this.messages[index]);
    }
  }

  close() {
    this.toggleChatPanel.emit(this.isShowChatPanel);
  }

  showPrompt() {
    this.isShowPrompt = true;
  }
}
